module.exports = __webpack_public_path__ + "img/1696322275603-WhatsApp Image 2023-10-02 at 12.09.38.jpeg.ce489f44.webp";